import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Bs4Tooltip from '../../Bs4Components/Bs4Tooltip';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions }  from '@mui/material/Autocomplete';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Chip from '@mui/material/Chip';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import AddIcon from '@mui/icons-material/Add';
import { getBs4Style } from '../../Bs4Components/Bs4Utils'
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import Popper from '@mui/material/Popper';
import Bs4ModalTopCenter from '../../Bs4Components/Bs4ModalTopCenter';

import Bs4Stores from '../../Bs4Stores';
import Bs4GenericField from './Bs4GenericField';
import Bs4MainDispatch from '../../Bs4MainDispatch'
import * as Bs4Utils from '../../Bs4Components/Bs4Utils'
import Avatar from '@mui/material/Avatar';
import { SmallScreenContext } from '../../Bs4Theme/Bs4UxTemplates';

const reorderDraggableOptions = (event, option, value, drag, formField) => {
  if (! drag.dragStartOption) return;
  if (drag.dragStartOption === option) return;
  if (drag.dragOverOption === option) return;

  const valueWithoutDraggedOption = value.filter(option => option !== drag.dragStartOption);
  if (option === "INPUT") {
    valueWithoutDraggedOption.push(drag.dragStartOption);
  } else {
    valueWithoutDraggedOption.splice(valueWithoutDraggedOption.indexOf(option), 0, drag.dragStartOption);
  }
  // console.log('...???...', drag)
  formField.setValue(valueWithoutDraggedOption);
  drag.dragOverOption = option;
}

const handleChipDragStart = (event, option, drag) => {
  //console.log('... drag', event.type, event, option)
  drag.dragStartOption = option;
  event.target.style.opacity = '0.2';
}

const handleChipDragEnd = (event, option, drag) => {
  drag.dragStartOption = null;
  event.target.style.opacity = '1';
}

const handleChipDragOver = (event, option, value, drag, formField) => {      
  if (formField.readOnly) return;
  if (event.target.nodeName !== "SPAN") return;
  reorderDraggableOptions(event, option, value, drag, formField);
}

const handleChipDragOverTF = (event, value, drag, formField) => {
  if (formField.readOnly) return;
  if (event.target.nodeName !== "INPUT") return;
  reorderDraggableOptions(event, "INPUT", value, drag, formField)
}

const getOptionStyle = (option) => {
  if (option && !option.bs4Style) option.bs4Style = getBs4Style(option?.style) || null
  return option.bs4Style;
}


const ViewOptionIcon = (props) => {
  getOptionStyle(props.option);
  if (props.option?.bs4Style && !props.option.icon) props.option.icon = 'fa-solid fa-circle';
  if (props.option?.icon) {
    return (
      <Bs4Tooltip arrow title={
        <React.Fragment>
          <Typography variant='body1'>{props?.option?.name}</Typography>
          <Typography variant='body2' sx={{whiteSpace: 'pre-line'}}>{props?.option?.text}</Typography>
        </React.Fragment>
        }
      >
        <Avatar 
          sx={{
            ...getOptionStyle(props.option),
            width: 25, 
            height: 25, 
            fontSize: 15,
          }}
        >
          <Box className={props.option?.icon}/>
        </Avatar>
      </Bs4Tooltip>
    )       
  }
  return null
};

const ViewOption = (props) => {
  return (
    <Stack
      component='li'
      {...props.props}
      direction='row'
      justifyContent='flex-start'
      alignItems= 'flex-start'//'center'
      spacing={1}        
    >
      <Checkbox size='small' checked={props.selected}/>
      <ViewOptionIcon option={props.option}/>
      <Stack component='span' direction='column' justifyContent='flex-start' alignItems='flex-start' spacing={0}>
        <Typography sx={{4: 'pre-line'}}>{props?.option?.name}</Typography>
        {props?.option?.text ? <Typography variant='body2' sx={{whiteSpace: 'pre-line', opacity: 0.7}}>{props?.option?.text}</Typography> : null}
      </Stack>
    </Stack>
  )
};

const ViewAvatar = (props) => {
  const sx = React.useMemo(() => getOptionStyle(props.option), [props.option]);
  if (!props.option?.icon) return null;
  return (
    <Avatar className={props.className} sx={sx}>
      <Box sx={sx} className={props.option?.icon || 'fa-solid fa-circle'}/>
    </Avatar>
  )
};

const ChipOptionLabel = (props) => {    
  const handleClick = (event) => {
    props.onClickLabel(props.option);
  }

  if (props.linkvalue) return (
    <Link href='#' onClick={handleClick}>{props.option.name}</Link>
  );

  if (props.filter_attrs_4) return (
    <span style={{color: '#000000', fontWeight: 'bold'}}>{props.option.name}</span>
  )
  
  return <Box component='span'>{props.option.name}</Box>
}   

const getSelectedOptions = (options, value) => {
  if (!Array.isArray(value)) return [];
  if (!Array.isArray(options)) return [];
  return options.filter(option => Boolean(value.find(v => option.id === v.id)));
}

const getNoSelectedOptions = (options, value) => {
  if (!Array.isArray(value)) return [];
  if (!Array.isArray(options)) return [];
  return options.filter(option => !Boolean(value.find(v => option.id === v.id)));
}

export default class Bs4Multiple extends Bs4GenericField {

  canCloseCriteria = false;
  
  setValueBs4(value) {
    if (Bs4Utils.isString(value)) value = value.split(',');
    if (Array.isArray(value)) value = value.map(id => String(id).trim());
    else {
      console.log('=== ERROR Bs4Multiple value not Array :', value)
      value = [];
    }    
    if (!Array.isArray(this.bs4Store)) this.bs4Store = [];
    this.bs4Store = Bs4Stores.addUnknownValuesToStore(this.bs4Store, value);
    value = Bs4Stores.idsToStoreObject(this.bs4Store, value);
    this.setValue(value);    
  }

  getValueBs4() {
    return this.getValue() ? this.getValue().map(item => item.id) : [];
  }

  elementAddValue(value) {			
    const ids = this.getValueBs4();
    ids.push(String(value));
    this.setValueBs4(ids);    
  };

  isDifferentValues (oldValue, newVaue)  {    
    if (Array.isArray(oldValue) && Array.isArray(newVaue)) {
      if (oldValue.length !== newVaue.length) return true;     
      for (let i = 0; i < oldValue.length; i++) {
        if (oldValue[i] !== newVaue[i]) return true;
      }
    }
    return false;      
  }

  isNativelyClearable () {
    return true;
  }

  getShortValue = (full) => {
    let trueValues = 0;
    let shortValue = '';
    let separator = '';

    if (this.getValue()) this.getValue().forEach((item) => {
      trueValues++;
      shortValue += separator+item.name;
      separator = ', ';
    });    
    
    if (full) return shortValue;
    
    if (trueValues > 1) {
      return '('+trueValues+')';
    } 
    
    if (shortValue.length > 20) {
      return shortValue.substring(0, 17)+'...';
    }

    return shortValue;						
  }

  ViewSummaryDetails = (props) => {
    const formField = this;
    return <formField.ViewComponentFieldAutocomplete SummaryDetails/>;
  }

  handleClickLabel = (option) => {
     Bs4MainDispatch.commandParser('Bs4FormFieldValue', {bs4multiselected: option.id, currFormId: this.props.field.formId}, this.bs4KartotekaId);
  }

  handleEditList = (e) => {
    const details = this.props.criterion
    ? {currFormId: this.props.field.formId, targetObject: this.props.field.ed_storebs4, targetOption: 343}
    : {currFormId: this.props.field.formId, targetObject: this.props.field.ed_storebs4, targetOption: 343}; 
    Bs4MainDispatch.commandParser('Bs4OpenCard', details, this.bs4KartotekaId);
  };

  ViewComponentField = (props) => {
    const formField = this;
    const [adornmentVisibility, setAdornmentVisibility] = React.useState('hidden');    

    const handleAdd = (e) => {
      Bs4MainDispatch.commandParser('Bs4FieldIconPlus', { currFormId: this.props.field.formId }, this.bs4KartotekaId);
    }

    return (
      <Box 
        width='100%'
        sx={{display: 'flex', alignItems: 'flex-end'}}
        onMouseEnter={() => setAdornmentVisibility('visible')} 
        onMouseLeave={() => setAdornmentVisibility('hidden')}
      >
        <formField.ViewComponentFieldAutocomplete {...props}/>
        {formField.isParamSelected('ATRYB_PLUS') ? 
          <IconButton onClick={handleAdd}>
            <AddIcon fontSize='small' sx={{visibility: adornmentVisibility}}/>
          </IconButton> 
        : null}
      </Box>
    );
  }

  linkvalue = this.isParamSelected('LINKVALUE');

  PopperStandard = function (props) {      
    return (<Popper {...props} style={{ width: 250 }} placement='bottom-start'/>)
  }
  
  PopperDialogFlat = function (props) {
    return props.children;    
  }

  PopperDialog = (props) => {
    const formField = this;      
  
    return (
      <Bs4ModalTopCenter
        bs4KartotekaId={formField.bs4KartotekaId}
        open={props.open}
        onClose={props.onClose}
      >
        <formField.ViewComponentField {...props} variantDialog/>
      </Bs4ModalTopCenter>
    )
  }

  PaperStandard = (props) => {
    const formField = this;
    const { children, filteredoptions: filteredOptions, value, ...restPaperProps } = props;    
    const edStoreBs4 = React.useMemo(() => formField.props.field.ed_storebs4, []);
  
    let selectAll = false;
    let indeterminate = false;
    const selectedOptions = getSelectedOptions(filteredOptions.current, value);
    if (filteredOptions.current.length === 0 || selectedOptions.length === 0) {
      selectAll = false;
      indeterminate = false;
    } else if (selectedOptions.length === filteredOptions.current.length) {
      selectAll = true;
      indeterminate = false;
    } else {
      selectAll = false;
      indeterminate = true;
    }  
  
    const text = formField.text_SelectAll.replace('%s', String(filteredOptions.current?.length || 0));      
    
    const handleToggleSelectAll = React.useCallback(() => {
      const newValue = filteredOptions.current;      
      const oldValue = getSelectedOptions(filteredOptions.current, value); 
      let select = true;
      if (filteredOptions.current.length > 0 && oldValue.length > 0 && filteredOptions.current.length !== oldValue.length) select = false;
      if (filteredOptions.current.length === oldValue.length) select = false; 
      if (select) {
        formField.setValue([...value, ...newValue]);
      } else {
        formField.setValue(getNoSelectedOptions(value, newValue));
      }
    }, [filteredOptions, value, props]);
    
    return (
      <Paper {...props}>
        {Boolean(edStoreBs4) ? 
          <MenuItem
            onMouseDown={(e) => e.preventDefault()} // prevent blur
            onClick={(e) => {
              e.preventDefault(); // prevent blur
              formField.handleEditList();
            }}
          >
            <Checkbox size='small' checked={false} sx={{visibility: 'hidden'}}/>
            <ListItemText secondary={formField.text_EditList} sx={{whiteSpace: 'pre-line'}}/>
          </MenuItem>
        : null}
        <MenuItem divider
          onMouseDown={(e) => e.preventDefault()} // prevent blur
          onClick={(e) => {
            e.preventDefault(); // prevent blur
            handleToggleSelectAll();
          }}
        >
          <Checkbox size='small' checked={selectAll} indeterminate={indeterminate}/>
          <ListItemText secondary={text} sx={{whiteSpace: 'pre-line'}}/>
        </MenuItem>
        {children}
      </Paper>
    );
  }
  
  PaperDialog = (props) => {
    const formField = this;
    const { children, filteredoptions: filteredOptions, value, ...restPaperProps } = props;    
    const edStoreBs4 = React.useMemo(() => formField.props.field.ed_storebs4, []);
  
    let selectAll = false;
    let indeterminate = false;
    const selectedOptions = getSelectedOptions(filteredOptions.current, value);
    if (filteredOptions.current.length === 0 || selectedOptions.length === 0) {
      selectAll = false;
      indeterminate = false;
    } else if (selectedOptions.length === filteredOptions.current.length) {
      selectAll = true;
      indeterminate = false;
    } else {
      selectAll = false;
      indeterminate = true;
    }  
  
    const text = formField.text_SelectAll.replace('%s', String(filteredOptions.current?.length || 0));      
    
    const handleToggleSelectAll = React.useCallback(() => {
      const newValue = filteredOptions.current;      
      const oldValue = getSelectedOptions(filteredOptions.current, value); 
      let select = true;
      if (filteredOptions.current.length > 0 && oldValue.length > 0 && filteredOptions.current.length !== oldValue.length) select = false;
      if (filteredOptions.current.length === oldValue.length) select = false; 
      if (select) {
        formField.setValue([...value, ...newValue]);
      } else {
        formField.setValue(getNoSelectedOptions(value, newValue));
      }
    }, [filteredOptions, value, props]);
    
    return (
      <Box {...props}>
        <MenuItem divider
          onMouseDown={(e) => e.preventDefault()} // prevent blur
          onClick={(e) => {
            e.preventDefault(); // prevent blur
            handleToggleSelectAll();
          }}
        >
          <Checkbox size='small' checked={selectAll} indeterminate={indeterminate}/>
          <ListItemText secondary={text} sx={{whiteSpace: 'pre-line'}}/>        
        </MenuItem>
        {children}      
        <Stack direction="row" spacing={1} sx={{justifyContent: "space-between", alignItems: "center", width: '100%', p: 1}}>                
          {Boolean(edStoreBs4) ? 
            <Button
              onMouseDown={(e) => e.preventDefault()} // prevent blur
              onClick={(e) => {
                e.preventDefault(); // prevent blur
                formField.handleEditList();
              }}
            >
              {formField.text_EditList}
            </Button>
          : null}
          <Box/>
          <Button 
            onMouseDown={(e) => e.preventDefault()} // prevent blur
            onClick={(e) => {
              e.preventDefault(); // prevent blur
              props.onClose(e, 'OK');
            }}
          >
            {'Ok'}
          </Button>
        </Stack>
      </Box>
    );
  }

  ViewComponentFieldAutocomplete = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue());
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)    
    const [open, setOpen] = React.useState(false);
    const filteredOptions = React.useRef([]);    
    const smallScreen = React.useContext(SmallScreenContext);
    this.refFocus = React.useRef();    
    const ref = React.useRef(null);    

    const paper = React.useMemo(() => {
      if (props.variantDialog) return this.PaperDialog;
      return this.PaperStandard;
    }, [props.variantDialog]);

    const popper = React.useMemo(() => {
      if (props.variantDialog) return this.PopperDialogFlat;
      if (smallScreen) return this.PopperDialog;
      return this.PopperStandard;
    }, [smallScreen, props.variantDialog]);
    
    const drag = React.useRef({
      dragStartOption: null,
      dragOverOption: null,
    })    

    const autocompletefilterOptions = React.useMemo(() => {
      return createFilterOptions();
    }, []);

    const filterOptions = React.useCallback((options, state) => {
      const results = autocompletefilterOptions(options, state);
      filteredOptions.current = results;
      return results;
    }, [filteredOptions]);    

    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(newValue);
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })
    }, [error]);    

    const handleChangeValue = (event, newValue, reason) => {
      this.setValue(newValue);
      if (props.SummaryDetails) this.reloadGridCriteria();
    }    

    const handleChipMouseDown = (event, option) => {
      //console.log('... drag', event.type, event, option)
      event.stopPropagation()
    }
    
    const popupIcon = React.useMemo(() => {
      if (props.variantDialog) return {popupIcon: null}      
      return {};
    }, [props.variantDialog]);
                                                                      
    //formField.readOnly = true    

    const handleOpenAutocomplete = React.useCallback((event) => {
      // console.log('...Multiple...OpenAutocomplete...');
      setOpen(true);
    }, [setOpen]);

    const handleCloseAutocomplete = React.useCallback((event, reason) => {
      // console.log('...Multiple...CloseAutocomplete...', reason, props);
      if ((reason === 'blur' || reason === 'toggleInput') && popper === this.PopperDialog) return;  
      setOpen(false);
      if (props.onClose) props.onClose(event, reason);
    }, [setOpen, popper]);
    
    React.useEffect(() => {
      const closeForm = (event) => {
        handleCloseAutocomplete(event, Bs4GenericField.CLOSE_BS4_FORM);
      }

      this.bs4Form.eventEmit.on(Bs4GenericField.CLOSE_BS4_FORM, closeForm);

      return () => this.bs4Form.eventEmit.off(closeForm);
    }, [handleCloseAutocomplete]);

    // console.log('...Multiple...', smallScreen, props.variantDialog, open);

    return (      
      <Stack 
        direction="column" 
        spacing={0} 
        sx={{justifyContent: "flex-start", alignItems: "flex-start", width: props.SummaryDetails ? 'auto' : '100%', minWidth: 200}}
      >
      <Autocomplete
        ref={ref}
        open={open || Boolean(props.variantDialog)}
        {...popupIcon}
        onOpen={handleOpenAutocomplete}
        onClose={handleCloseAutocomplete}
        readOnly={formField.readOnly}
        freeSolo={formField.readOnly}
        filterOptions={filterOptions}
        fullWidth={!props.SummaryDetails}
        multiple
        disableCloseOnSelect
        value={value}
        onChange={handleChangeValue}
        options={formField.bs4Store}
        getOptionLabel={option => option?.name}
        isOptionEqualToValue={(option, value) => option.id == value.id}
        disableClearable={!Boolean(formField.readOnly)}        
        // forcePopupIcon

        sx={props.SummaryDetails ? {minWidth: 180} : {}}

        renderInput={(params) => {
          params.InputProps.disableUnderline = formField.readOnly;
          return (
          <TextField 
            {...params}
            label={props.SummaryDetails ? null : <formField.Bs4Label/>} 
            slotProps={{inputLabel: formField.props.field.hideLabel ? {sx:{display:'none'}} : null}}
            inputRef={this.refFocus} 
            error={error.error} 
            helperText={error.helperText}              
            onDragOver={(e) => handleChipDragOverTF(e, value, drag.current, formField)}
          />
        )}}
        renderOption={(props, option, { selected }) => (          
          <ViewOption key={option.id} props={props} option={option} selected={selected}/>
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip                
              {...getTagProps({index})} 
              key={option.id} // ! ! !
              avatar={<ViewAvatar option={option}/>}
              label={
                <ChipOptionLabel 
                  option={option} 
                  linkvalue={formField.linkvalue} 
                  filter_attrs_4={formField.filter_attrs_4} 
                  onClickLabel={formField.handleClickLabel}
                />
              }
              draggable
              onMouseDown={(e) => handleChipMouseDown(e, option)}
              onDragStart={(e) => handleChipDragStart(e, option, drag.current)}
              onDragEnd={(e) => handleChipDragEnd(e, option, drag.current)}
              onDragOver={(e) => handleChipDragOver(e, option, value, drag.current, formField)}
            />
          ))
        }  
        slots={{
          paper: paper,
          popper: popper,
        }} 
        slotProps={{
          paper: {
            filteredoptions: filteredOptions,
            value: value,
            onClose: handleCloseAutocomplete,
          },
          popper: {        
            sx: { minWidth: 'fit-content' },
            onClose: handleCloseAutocomplete,
          }
        }}   
      />              
      </Stack>
    );
  }
}